var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "step2" }, [
    _c("div", { staticClass: "step2__content" }, [
      _c("p", { staticClass: "step2__header" }, [
        _vm._v("Please Select a Date and Time"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "step2__calendar" }, [
        _vm.loading
          ? _c("div", { staticClass: "step2__loader" }, [
              _c("div", { staticClass: "step2__loader-spinner" }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "step2__upper" }, [
          _c(
            "select",
            {
              staticClass: "step2__select",
              attrs: { name: "monthYear", id: "monthYear" },
              on: { change: _vm.onMonthSelect },
            },
            _vm._l(_vm.monthOptions, function (option) {
              return _c(
                "option",
                {
                  key: option.value,
                  domProps: {
                    value: option.value,
                    selected: option.value === _vm.currentMonthValue,
                  },
                },
                [
                  _vm._v(
                    "\n              " + _vm._s(option.label) + "\n            "
                  ),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "step2__headerControls" }, [
            _c(
              "button",
              {
                staticClass: "step2__action",
                attrs: { disabled: !_vm.canGoToPreviousWeek },
                on: {
                  click: function ($event) {
                    return _vm.changeWeek("prev")
                  },
                },
              },
              [_c("IconChevronLeftBlue")],
              1
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "step2__today",
                on: {
                  click: function ($event) {
                    return _vm.backToToday()
                  },
                },
              },
              [_vm._v("Today")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "step2__action",
                on: {
                  click: function ($event) {
                    return _vm.changeWeek("next")
                  },
                },
              },
              [_c("IconChevronRightBlue")],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "step2__body" }, [
          _c("div", { staticClass: "step2__navigation" }, [
            _c(
              "div",
              { staticClass: "step2__days" },
              _vm._l(_vm.calendar.week, function (day) {
                return _c(
                  "div",
                  { staticClass: "step2__day", class: _vm.getDayState(day) },
                  [
                    _c("p", [_vm._v(_vm._s(day.title))]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        _vm._s(_vm.helpers().formatterDayShorthand(day.date))
                      ),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "step2__timeslots" },
            _vm._l(_vm.calendar.week, function (day) {
              return _c(
                "div",
                { staticClass: "step2__columns" },
                _vm._l(day.timeslots, function (timeslot) {
                  return _c(
                    "button",
                    {
                      staticClass: "step2__timeslot",
                      class: [{ active: _vm.selectedTimeslot === timeslot }],
                      on: {
                        click: function ($event) {
                          return _vm.selectTimeslot(timeslot)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.helpers().formatterTime(timeslot.dateTime)
                          ) +
                          "\n              "
                      ),
                    ]
                  )
                }),
                0
              )
            }),
            0
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "step2__timeslots" },
        _vm._l(_vm.activeDay.timeslots, function (timeslot) {
          return _c(
            "button",
            {
              class: [{ active: _vm.selectedTimeslot === timeslot }],
              on: {
                click: function ($event) {
                  return _vm.selectTimeslot(timeslot)
                },
              },
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.helpers().formatterTime(timeslot.dateTime)) +
                  "\n        "
              ),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.unavailable
        ? _c("label", { staticClass: "step2__notice" }, [
            _vm._v(
              "We are sorry, but we have no available appointments for this period. Call us to schedule an appointment"
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }